// ----------------------------------------------------------------------------
// Стартовый файл для скриптов ЛК пользователя (подключается дополнительно)
// ----------------------------------------------------------------------------



import ttAuth_tab_click from "./tt-auth-tab-click.js";
import accept_agreement from "../misc/accept-agreement.js";
import listenersMyaccountMisc from "../listeners/myaccount-misc.js";
import handleAuthSubmit from "./auth-email/handle-auth-submit.js";
import initAuthMessageListener from "./auth-message-listener.js";
import {ttAuthPasswordRenew} from "./password-controller.js";
import {accountElements} from "./auth-account-elements.js";
import {deleteAccountHelp} from "../account/delete-something.js";



window.actionType = '';


initAuthMessageListener(); // слушатель ответа от отправки формы

document.addEventListener('DOMContentLoaded', () => {
    // ----------------------------------------------------------------------------
    // СПЛЕШ-СТРАНИЦА АВТОРИЗАЦИИ

    // клик по кнопке "Войти на сайт" на странице сплеш-авторизации
    document.querySelector('.js-ttAuth_save')?.addEventListener('click', handleAuthSubmit);

    // переключение табов регистрация/авторизация
    document.getElementById('ttAuth_tab_registration')?.addEventListener('click', async (e) => {
        await ttAuth_tab_click(e, 'registration');
    });
    document.getElementById('ttAuth_tab_enter')?.addEventListener('click', async (e) => {
        await ttAuth_tab_click(e, 'enter');
    });

    // потому что при определенных случаях ссылки вспомнить пароль добавляются по действию пользователя
    const passContainer = document.querySelector('.auth-registration-wrapper');
    passContainer?.addEventListener('click', (event) => {
        const target = event.target.closest('.js-remember_pass');
        if (target) {
            ttAuthPasswordRenew();
        }
    });

    // и для ссылок, существующих сразу
    const passRememberLinks = document.querySelectorAll('.js-remember-password');
    passRememberLinks.forEach(() => {
        ttAuthPasswordRenew();
    })




    // ----------------------------------------------------------------------------
    // СТРАНИЦА ЛК

    accountElements.accountDel?.addEventListener('click', (e) => {
        deleteAccountHelp(e);
    });

    listenersMyaccountMisc(); // слушатели разных элементов на странице ЛК
    document.querySelector('.js-agreement-accept')?.addEventListener('click', accept_agreement);
})








